import type { IHubContentProvider } from "./providers";

export enum IHubContentType {
    INSIGHTS = "INSIGHTS",
    MARKETING_CONTENT = "MARKETING_CONTENT",
}

export type IHubContentSubType = {
    provider: IHubContentProvider;
    scope?: string;
};
